import { lf } from '@/api/data/lovefield';
import { upgradeLxInfo } from '@/api/data/tables/contact_upgrade_lx_info';
let oldVersion = 12;
const addType2OrgContact = (trans) => {
    console.log('[table/contact]', trans);
};
const contact = {
    name: 'contact_dexie',
    using: ['dexie'],
    version: 19,
    cache: true,
    versionchange: e => {
        oldVersion = e.oldVersion;
    },
    upgrade: async (trans) => {
        console.warn('[tables/contact]upgrade:', oldVersion);
        if (oldVersion < 15) {
        }
        if (oldVersion < 16) {
            addType2OrgContact(trans);
        }
        if (oldVersion < 18) {
            await upgradeLxInfo(trans);
        }
    },
    tables: [
        {
            name: 'personal_mark',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'type',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'value',
                    type: lf.Type.STRING,
                },
                {
                    name: 'name',
                    type: lf.Type.STRING,
                },
                {
                    name: 'emails',
                    type: lf.Type.STRING_ARRAY,
                },
                {
                    name: 'originId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'unreadMailCount',
                    type: lf.Type.STRING,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['type'],
                },
                {
                    columns: ['value'],
                },
                {
                    name: 'personalMarkEmail',
                    columns: ['emails'],
                    multi: true,
                    unique: false,
                    order: lf.Order.ASC,
                },
            ],
        },
        {
            name: 'contact',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'contactLabel',
                    type: lf.Type.STRING,
                },
                {
                    name: 'accountStatus',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'accountVisible',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'contactPYName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'contactName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'accountName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'enterpriseId',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'accountOriginId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'enableIM',
                    type: lf.Type.BOOLEAN,
                },
                {
                    name: 'type',
                    type: lf.Type.STRING,
                },
                {
                    name: 'remark',
                    type: lf.Type.STRING,
                },
                {
                    name: 'position',
                    type: lf.Type.STRING,
                },
                {
                    name: 'avatar',
                    type: lf.Type.STRING,
                },
                {
                    name: 'visibleCode',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'updateTime',
                    type: lf.Type.DATE_TIME,
                },
                {
                    name: 'contactPYLabelName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'marked',
                    type: lf.Type.STRING,
                },
                {
                    name: 'source',
                    type: lf.Type.STRING,
                },
                {
                    name: '_lastUpdateTime',
                    type: lf.Type.INTEGER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['accountOriginId'],
                },
                {
                    columns: ['contactPYName'],
                },
                {
                    columns: ['contactName'],
                },
                {
                    columns: ['accountName'],
                },
                {
                    columns: ['contactPYLabelName'],
                },
                {
                    columns: ['type', 'contactLabel'],
                },
                {
                    columns: ['_lastUpdateTime'],
                },
                {
                    columns: ['enterpriseId', '_lastUpdateTime'],
                },
                {
                    columns: ['type', '_lastUpdateTime'],
                },
            ],
            nullable: ['remark', 'position', 'updateTime', 'avatar'],
        },
        {
            name: 'contactItem',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'contactItemVal',
                    type: lf.Type.STRING,
                },
                {
                    name: 'contactItemType',
                    type: lf.Type.STRING,
                },
                {
                    name: 'type',
                    type: lf.Type.STRING,
                },
                {
                    name: 'isDefault',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'emailType',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'contactId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'unreadItemCount',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'useFrequency',
                    type: lf.Type.STRING,
                },
                {
                    name: 'source',
                    type: lf.Type.STRING,
                },
                {
                    name: 'updateTime',
                    type: lf.Type.DATE_TIME,
                },
                {
                    name: '_lastUpdateTime',
                    type: lf.Type.NUMBER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['contactItemVal'],
                },
                {
                    columns: ['contactItemType'],
                },
                {
                    columns: ['contactId'],
                },
                {
                    columns: ['contactItemType', 'enterpriseId', '_lastUpdateTime'],
                },
                {
                    columns: ['type', '_lastUpdateTime'],
                },
            ],
            nullable: ['unreadItemCount', 'useFrequency', 'updateTime'],
        },
        {
            name: 'orgContact',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'contactId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'enterpriseId',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'orgId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'imId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'yunxinId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'nickInTeam',
                    type: lf.Type.STRING,
                },
                {
                    name: 'joinTime',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'type',
                    type: lf.Type.STRING,
                },
                {
                    name: '_lastUpdateTime',
                    type: lf.Type.INTEGER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                { columns: ['contactId'] },
                { columns: ['orgId'] },
                { columns: ['imId'] },
                { columns: ['yunxinId'] },
                { columns: ['type'] },
                { columns: ['enterpriseId', '_lastUpdateTime'] },
                { columns: ['type', '_lastUpdateTime'] },
            ],
        },
        {
            name: 'org',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'enterpriseId',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'originId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'orgRank',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'orgName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'orgPYName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'type',
                    type: lf.Type.STRING,
                },
                {
                    name: 'parent',
                    type: lf.Type.STRING,
                },
                {
                    name: 'level',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'visibleCode',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'childrenCount',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'marked',
                    type: lf.Type.INTEGER,
                },
                {
                    name: 'source',
                    type: lf.Type.STRING,
                },
                {
                    name: '_lastUpdateTime',
                    type: lf.Type.INTEGER,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    columns: ['originId'],
                },
                {
                    columns: ['orgName'],
                },
                {
                    columns: ['orgPYName'],
                },
                {
                    columns: ['parent'],
                },
                {
                    columns: ['type'],
                },
                {
                    columns: ['orgRank'],
                },
                {
                    columns: ['enterpriseId', '_lastUpdateTime'],
                },
                {
                    columns: ['type', '_lastUpdateTime'],
                },
            ],
            nullable: ['childrenCount', 'level', 'type'],
        },
        {
            name: 'email_list',
            columns: [
                {
                    name: 'accountName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'contactName',
                    type: lf.Type.STRING,
                },
                {
                    name: 'createTime',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'updateTime',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'mailIds',
                    type: lf.Type.STRING_ARRAY,
                },
                {
                    name: 'priority',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'latestSendTime',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'isSystemAccount',
                    type: lf.Type.BOOLEAN,
                },
            ],
            primaryKey: {
                columns: ['accountName'],
            },
            index: [
                {
                    columns: ['priority'],
                },
                {
                    name: 'mailIdIdx',
                    columns: ['mailIds'],
                    unique: false,
                    multi: true,
                    order: lf.Order.ASC,
                },
            ],
            nullable: ['latestSendTime', 'contactName'],
        },
        {
            name: 'recent_contact',
            columns: [
                {
                    name: 'email',
                    type: lf.Type.STRING,
                },
                {
                    name: 'accountId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'iconUrl',
                    type: lf.Type.STRING,
                },
                {
                    name: 'nickname',
                    type: lf.Type.STRING,
                },
                {
                    name: 'index',
                    type: lf.Type.INTEGER,
                },
            ],
            primaryKey: {
                columns: ['index'],
            },
            index: [
                {
                    name: 'recentContactIdx',
                    columns: ['email'],
                    unique: false,
                    order: lf.Order.ASC,
                },
            ],
        },
        {
            name: 'frequentContact',
            columns: [
                {
                    name: 'id',
                    type: lf.Type.STRING,
                },
                {
                    name: 'contactId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'email',
                    type: lf.Type.STRING,
                },
                {
                    name: 'timestamp',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'sendcount',
                    type: lf.Type.NUMBER,
                },
                {
                    name: 'type',
                    type: lf.Type.STRING,
                },
                {
                    name: 'channel',
                    type: lf.Type.STRING,
                },
            ],
            primaryKey: {
                columns: ['id'],
            },
            index: [
                {
                    name: 'frequentComposeIndex',
                    columns: ['contactId', 'channel'],
                },
                {
                    columns: ['timestamp'],
                },
            ],
        },
        {
            name: 'lx_info',
            columns: [
                {
                    name: 'contactId',
                    type: lf.Type.STRING,
                },
                {
                    name: 'avatar',
                    type: lf.Type.STRING,
                },
                {
                    name: 'yxid',
                    type: lf.Type.STRING,
                },
                {
                    name: 'yxToken',
                    type: lf.Type.STRING,
                },
            ],
            primaryKey: {
                columns: ['contactId'],
            },
            nullable: ['avatar', 'yxid', 'yxToken'],
        },
    ],
};
export default contact;
